(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function ProductSlider(root) {
      this.root = root;
      this.viewport = root.querySelector('.product-slider__viewport');
      this.track = root.querySelector('.product-slider__track');
      this.originalSlides = Array.prototype.slice.call(this.track.children);
      this.slidesCount = this.originalSlides.length;
      this.prevBtn = root.querySelector('.product-slider__arrow--prev');
      this.nextBtn = root.querySelector('.product-slider__arrow--next');
      this.dotsWrap = root.querySelector('.product-slider__dots');

      this.infinite = root.getAttribute('data-infinite-loop') === 'true';
      this.autoplayEnabled = root.getAttribute('data-autoplay') === 'true';
      this.autoplaySpeed = (parseFloat(root.getAttribute('data-autoplay-speed')) || 3) * 1000;
      this.pauseOnHover = root.getAttribute('data-pause-on-hover') === 'true';

      this.currentIndex = 0;
      this.isDragging = false;
      this.startX = 0;
      this.dragStartTranslate = 0;
      this.autoplayTimer = null;
      this.resizeTimer = null;

      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onTransitionEnd = this.onTransitionEnd.bind(this);
      this.onResize = this.onResize.bind(this);
      this.next = this.next.bind(this);
      this.prev = this.prev.bind(this);

      this.init();
    }

    ProductSlider.prototype.init = function () {
      if (this.slidesCount === 0) {
        return;
      }

      if (this.infinite && this.slidesCount > 1) {
        this.setupInfiniteClones();
      } else {
        this.currentIndex = 0;
      }

      this.buildDots();
      this.bindEvents();
      this.goToSlide(this.currentIndex, false);
      this.startAutoplay();
    };

    ProductSlider.prototype.setupInfiniteClones = function () {
      var startFragment = document.createDocumentFragment();
      var endFragment = document.createDocumentFragment();

      this.originalSlides.forEach(function (slide) {
        startFragment.appendChild(slide.cloneNode(true));
      });
      this.originalSlides.forEach(function (slide) {
        endFragment.appendChild(slide.cloneNode(true));
      });

      this.track.insertBefore(startFragment, this.track.firstChild);
      this.track.appendChild(endFragment);

      this.currentIndex = this.slidesCount;
    };

    ProductSlider.prototype.buildDots = function () {
      if (!this.dotsWrap || this.slidesCount <= 1) {
        return;
      }

      var self = this;
      this.dots = [];

      for (var i = 0; i < this.slidesCount; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-slider__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        (function (index) {
          dot.addEventListener('click', function () {
            self.stopAutoplay();
            var target = self.infinite ? self.slidesCount + index : index;
            self.goToSlide(target, true);
            self.startAutoplay();
          });
        })(i);
        this.dotsWrap.appendChild(dot);
        this.dots.push(dot);
      }

      this.updateDots();
    };

    ProductSlider.prototype.updateDots = function () {
      if (!this.dots || this.dots.length === 0) {
        return;
      }

      var realIndex = this.infinite
        ? ((this.currentIndex - this.slidesCount) % this.slidesCount + this.slidesCount) % this.slidesCount
        : this.currentIndex % this.slidesCount;

      this.dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === realIndex);
      });
    };

    ProductSlider.prototype.getStep = function () {
      var allSlides = this.track.children;
      if (!allSlides.length) {
        return 0;
      }
      var slideRect = allSlides[0].getBoundingClientRect();
      var gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap || 0);
      return slideRect.width + gap;
    };

    ProductSlider.prototype.goToSlide = function (index, animate) {
      var totalSlides = this.track.children.length;
      if (totalSlides === 0) {
        return;
      }

      this.track.style.transition = animate ? 'transform 0.4s ease' : 'none';
      var step = this.getStep();
      var offset = -(index * step);
      this.track.style.transform = 'translateX(' + offset + 'px)';
      this.currentIndex = index;
      this.updateDots();
    };

    ProductSlider.prototype.onTransitionEnd = function () {
      if (!this.infinite) {
        return;
      }

      if (this.currentIndex >= this.slidesCount * 2) {
        this.goToSlide(this.currentIndex - this.slidesCount, false);
      } else if (this.currentIndex < this.slidesCount) {
        this.goToSlide(this.currentIndex + this.slidesCount, false);
      }
    };

    ProductSlider.prototype.next = function () {
      var maxIndex = this.track.children.length - 1;
      if (!this.infinite && this.currentIndex >= maxIndex) {
        return;
      }
      this.goToSlide(this.currentIndex + 1, true);
    };

    ProductSlider.prototype.prev = function () {
      if (!this.infinite && this.currentIndex <= 0) {
        return;
      }
      this.goToSlide(this.currentIndex - 1, true);
    };

    ProductSlider.prototype.startAutoplay = function () {
      if (!this.autoplayEnabled || this.slidesCount <= 1) {
        return;
      }
      this.stopAutoplay();
      var self = this;
      this.autoplayTimer = setInterval(function () {
        self.next();
      }, this.autoplaySpeed);
    };

    ProductSlider.prototype.stopAutoplay = function () {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    };

    ProductSlider.prototype.onPointerDown = function (e) {
      this.isDragging = true;
      this.startX = e.clientX;
      this.dragStartTranslate = -(this.currentIndex * this.getStep());
      this.track.style.transition = 'none';
      this.viewport.classList.add('is-dragging');
      if (this.viewport.setPointerCapture) {
        this.viewport.setPointerCapture(e.pointerId);
      }
      this.stopAutoplay();
    };

    ProductSlider.prototype.onPointerMove = function (e) {
      if (!this.isDragging) {
        return;
      }
      var dx = e.clientX - this.startX;
      this.track.style.transform = 'translateX(' + (this.dragStartTranslate + dx) + 'px)';
    };

    ProductSlider.prototype.onPointerUp = function (e) {
      if (!this.isDragging) {
        return;
      }
      this.isDragging = false;
      this.viewport.classList.remove('is-dragging');

      var dx = e.clientX - this.startX;
      var threshold = this.getStep() * 0.2;

      if (dx < -threshold) {
        this.next();
      } else if (dx > threshold) {
        this.prev();
      } else {
        this.goToSlide(this.currentIndex, true);
      }

      this.startAutoplay();
    };

    ProductSlider.prototype.onResize = function () {
      var self = this;
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(function () {
        self.goToSlide(self.currentIndex, false);
      }, 100);
    };

    ProductSlider.prototype.bindEvents = function () {
      var self = this;

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', function () {
          self.stopAutoplay();
          self.prev();
          self.startAutoplay();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', function () {
          self.stopAutoplay();
          self.next();
          self.startAutoplay();
        });
      }

      this.viewport.addEventListener('pointerdown', this.onPointerDown);
      this.viewport.addEventListener('pointermove', this.onPointerMove);
      this.viewport.addEventListener('pointerup', this.onPointerUp);
      this.viewport.addEventListener('pointercancel', this.onPointerUp);
      this.viewport.addEventListener('pointerleave', this.onPointerUp);

      this.track.addEventListener('transitionend', this.onTransitionEnd);

      window.addEventListener('resize', this.onResize);

      if (this.pauseOnHover) {
        this.root.addEventListener('mouseenter', function () {
          self.stopAutoplay();
        });
        this.root.addEventListener('mouseleave', function () {
          self.startAutoplay();
        });
      }
    };

    function initSliders(scope) {
      var roots = (scope || document).querySelectorAll('[data-product-slider]');
      roots.forEach(function (root) {
        if (root.getAttribute('data-slider-ready') === 'true') {
          return;
        }
        root.setAttribute('data-slider-ready', 'true');
        new ProductSlider(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initSliders(document);
      });
    } else {
      initSliders(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initSliders(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  class ContinuousCarousel {
    constructor(root) {
      this.root = root;
      this.viewport = root.querySelector('[data-pshowcase-viewport]');
      this.track = root.querySelector('[data-pshowcase-track]');

      if (!this.viewport || !this.track) return;

      this.baseCards = Array.from(this.track.children);
      this.cardCount = this.baseCards.length;
      if (this.cardCount < 1) return;

      this.prevBtn = root.querySelector('[data-pshowcase-prev]');
      this.nextBtn = root.querySelector('[data-pshowcase-next]');
      this.dotsHost = root.querySelector('[data-pshowcase-dots]');

      // px/sec — higher = faster continuous scroll
      this.speed = parseFloat(root.getAttribute('data-speed')) || 40;
      this.autoplay = root.getAttribute('data-autoplay') === 'true';
      this.pauseOnHover = root.getAttribute('data-hover-pause') === 'true';
      this.loop = root.getAttribute('data-loop') !== 'false';

      this.offset = 0;
      this.cardWidth = 0;
      this.setWidth = 0;
      this.rafId = null;
      this.prevFrameTime = null;

      this.dragging = false;
      this.dragStartX = 0;
      this.dragStartOffset = 0;
      this.dragMoved = 0;
      this.dragThreshold = 6; // px tolerance before we treat it as a real drag
      this.captured = false;
      this._pointerId = undefined;

      this._boundTick = this.tick.bind(this);

      this.setup();
    }

    setup() {
      this.cloneCards();
      this.recalculate();
      this.attachEvents();
      this.buildDots();
      this.play();
    }

    cloneCards() {
      if (this.track.dataset.cloned === 'true') return;
      const fragment = document.createDocumentFragment();
      this.baseCards.forEach((card) => fragment.appendChild(card.cloneNode(true)));
      this.track.appendChild(fragment);
      this.track.dataset.cloned = 'true';
    }

    recalculate() {
      const firstCard = this.track.children[0];
      if (!firstCard) return;

      const rect = firstCard.getBoundingClientRect();
      const computed = window.getComputedStyle(this.track);
      const gap = parseFloat(computed.columnGap || computed.gap || 0);

      this.cardWidth = rect.width + gap;
      this.setWidth = this.cardWidth * this.cardCount;

      if (this.setWidth > 0) {
        this.offset = ((this.offset % this.setWidth) + this.setWidth) % this.setWidth;
      }

      this.paint();
    }

    paint() {
      this.track.style.transform = `translate3d(${-this.offset}px, 0, 0)`;
    }

    tick(timestamp) {
      if (this.prevFrameTime === null) this.prevFrameTime = timestamp;
      let delta = (timestamp - this.prevFrameTime) / 1000;
      this.prevFrameTime = timestamp;
      if (delta > 0.05) delta = 0.05; // guard against tab-inactive jumps

      if (this.autoplay && !this.dragging) {
        this.offset += this.speed * delta;
        if (this.offset >= this.setWidth) this.offset -= this.setWidth;
        this.paint();
        this.syncDots();
      }

      this.rafId = requestAnimationFrame(this._boundTick);
    }

    play() {
      if (!this.autoplay || this.cardCount <= 1 || this.rafId) return;
      this.prevFrameTime = null;
      this.rafId = requestAnimationFrame(this._boundTick);
    }

    pause() {
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
      this.prevFrameTime = null;
    }

    goTo(direction) {
      this.offset += direction * this.cardWidth;
      if (this.offset >= this.setWidth) this.offset -= this.setWidth;
      if (this.offset < 0) this.offset += this.setWidth;
      this.paint();
      this.syncDots();
    }

    buildDots() {
      if (!this.dotsHost || this.cardCount <= 1) return;
      this.dotsHost.innerHTML = '';
      this.dots = [];

      for (let i = 0; i < this.cardCount; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pshowcase-carousel__dot';
        dot.setAttribute('aria-label', `Go to item ${i + 1}`);
        dot.addEventListener('click', () => {
          this.offset = i * this.cardWidth;
          this.paint();
          this.syncDots();
        });
        this.dotsHost.appendChild(dot);
        this.dots.push(dot);
      }
      this.syncDots();
    }

    syncDots() {
      if (!this.dots || !this.dots.length || !this.cardWidth) return;
      const active = Math.floor(this.offset / this.cardWidth) % this.cardCount;
      this.dots.forEach((dot, i) => dot.dataset.active = String(i === active));
    }

    attachEvents() {
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goTo(1));
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(-1));

      this.viewport.addEventListener('pointerdown', (e) => this.onPointerDown(e));
      this.viewport.addEventListener('pointermove', (e) => this.onPointerMove(e));
      this.viewport.addEventListener('pointerup', () => this.onPointerUp());
      this.viewport.addEventListener('pointercancel', () => this.onPointerUp());

      if (this.pauseOnHover) {
        this.root.addEventListener('mouseenter', () => this.pause());
        this.root.addEventListener('mouseleave', () => {
          if (this.autoplay && !this.dragging) this.play();
        });
      }

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => this.recalculate(), 150);
      });
    }

    onPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      this.dragging = true;
      this.dragStartX = event.clientX;
      this.dragStartOffset = this.offset;
      this.dragMoved = 0;
      this.captured = false;
      this._pointerId = event.pointerId;
      this.pause();
    }

    onPointerMove(event) {
      if (!this.dragging) return;
      const delta = event.clientX - this.dragStartX;
      this.dragMoved = Math.abs(delta);

      if (!this.captured && this.dragMoved > this.dragThreshold) {
        this.captured = true;
        this.viewport.dataset.dragging = 'true';
        if (this.viewport.setPointerCapture) {
          this.viewport.setPointerCapture(this._pointerId);
        }
      }

      if (!this.captured) return; // still within click tolerance, don't move track yet

      this.offset = this.dragStartOffset - delta;
      if (this.offset >= this.setWidth) this.offset -= this.setWidth;
      if (this.offset < 0) this.offset += this.setWidth;
      this.paint();
    }

    onPointerUp() {
      if (!this.dragging) return;
      this.dragging = false;

      if (this.captured) {
        this.viewport.dataset.dragging = 'false';
        if (this.viewport.releasePointerCapture && this._pointerId !== undefined) {
          try { this.viewport.releasePointerCapture(this._pointerId); } catch (e) {}
        }
        // real drag happened — swallow the click that follows so the product link doesn't fire
        const suppressClick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          document.removeEventListener('click', suppressClick, true);
        };
        document.addEventListener('click', suppressClick, true);
      }

      this.captured = false;
      if (this.autoplay) this.play();
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-pshowcase-carousel]').forEach((root) => {
      if (root.dataset.pshowcaseReady === 'true') return;
      root.dataset.pshowcaseReady = 'true';
      new ContinuousCarousel(root);
    });
  }

  // Filtering + sorting: submits the form via fetch to the collection's own URL
  // with a section_id param, then swaps in the returned results markup.
  class ProductShowcaseFilters extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      this.sectionId = this.getAttribute('data-section-id');
      this.baseUrl = this.getAttribute('data-url');
      this.form = this.querySelector('[data-pshowcase-form]');
      this.section = this.closest('.section-product-showcase');
      this.resultsEl = this.section ? this.section.querySelector('[data-pshowcase-results]') : null;

      if (!this.form || !this.baseUrl || !this.resultsEl) return;

      this.syncSortControls();
      if (!this._sortControlsMediaQuery) {
        this._sortControlsMediaQuery = window.matchMedia('(max-width: 749px)');
        this._onSortControlsMediaChange = () => this.syncSortControls();
        this._sortControlsMediaQuery.addEventListener('change', this._onSortControlsMediaChange);
      }

      this.form.addEventListener('change', (event) => {
        if (event.target.matches('input, select')) {
          this.submit();
        }
      });

      this.form.addEventListener('click', (event) => {
        const clearButton = event.target.closest('[on\\:click], .facets__clear-all-link, .clear-filter');
        if (clearButton) {
          const href = clearButton.getAttribute('href') || clearButton.dataset.url;
          if (href) {
            event.preventDefault();
            this.submit(href);
          }
        }
      });

      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.submit();
      });
    }

    disconnectedCallback() {
      if (this._sortControlsMediaQuery && this._onSortControlsMediaChange) {
        this._sortControlsMediaQuery.removeEventListener('change', this._onSortControlsMediaChange);
        this._sortControlsMediaQuery = null;
        this._onSortControlsMediaChange = null;
      }
    }

    syncSortControls() {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;

      this.querySelectorAll('select[name="sort_by"]').forEach((element) => {
        if (element instanceof HTMLSelectElement) {
          element.disabled = !isMobile;
        }
      });

      this.querySelectorAll('input[name="sort_by"]').forEach((element) => {
        if (element instanceof HTMLInputElement) {
          element.disabled = isMobile;
        }
      });
    }

    getSortByValue() {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;

      if (isMobile) {
        const select = this.querySelector('select[name="sort_by"]');
        return select instanceof HTMLSelectElement ? select.value : null;
      }

      const checkedRadio = this.querySelector('input[name="sort_by"]:checked');
      return checkedRadio instanceof HTMLInputElement ? checkedRadio.value : null;
    }

    normalizeSectionId(sectionId) {
      return sectionId.replace(/^shopify-section-/, '');
    }

    getSyncedSectionIds() {
      const sectionIds = new Set();

      if (this.sectionId) {
        sectionIds.add(this.normalizeSectionId(this.sectionId));
      }

      document.querySelectorAll('[data-collection-sort-target]').forEach((element) => {
        const section = element.closest('.shopify-section');
        if (!section?.id) return;
        sectionIds.add(this.normalizeSectionId(section.id));
      });

      return Array.from(sectionIds);
    }

    buildCollectionRequestUrl(overrideUrl) {
      if (overrideUrl) {
        return new URL(overrideUrl, window.location.origin);
      }

      const params = new URLSearchParams(new FormData(this.form));
      params.delete('sort_by');
      params.delete('page');
      params.delete('section_id');
      params.delete('sections');

      const sortBy = this.getSortByValue();
      if (sortBy) {
        params.set('sort_by', sortBy);
      }

      const collectionUrl = new URL(this.baseUrl, window.location.origin);
      const currentUrl = new URL(window.location.href);
      const url = currentUrl.pathname === collectionUrl.pathname
        ? new URL(currentUrl.href)
        : collectionUrl;

      url.search = '';
      params.forEach((value, key) => {
        if (value !== '') url.searchParams.append(key, value);
      });

      return url;
    }

    replaceSectionHtml(sectionId, html) {
      const selector = `#shopify-section-${sectionId}`;
      const target = document.querySelector(selector);
      if (!target || !html) return;

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newSection = doc.querySelector(selector)
        || doc.querySelector('.shopify-section')
        || doc.body?.firstElementChild;

      if (!newSection) return;
      target.innerHTML = newSection.innerHTML;
    }

    async submit(overrideUrl) {
      this.setAttribute('data-loading', 'true');

      try {
        const requestUrl = this.buildCollectionRequestUrl(overrideUrl);
        const sectionIds = this.getSyncedSectionIds();

        if (sectionIds.length === 0) return;

        const fetchUrl = new URL(requestUrl.href);
        fetchUrl.searchParams.set('sections', sectionIds.join(','));

        const response = await fetch(fetchUrl.toString());
        if (!response.ok) throw new Error('Request failed: ' + response.status);

        const sectionsHtml = await response.json();

        sectionIds.forEach((sectionId) => {
          this.replaceSectionHtml(sectionId, sectionsHtml[sectionId]);
        });

        initAll(document);

        const nextUrl = new URL(window.location.href);
        nextUrl.search = requestUrl.search;
        history.replaceState(null, '', nextUrl.toString());
      } catch (error) {
        console.error('Product showcase filter/sort request failed:', error);
      } finally {
        this.removeAttribute('data-loading');
      }
    }
  }

  if (!customElements.get('product-showcase-filters')) {
    customElements.define('product-showcase-filters', ProductShowcaseFilters);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
